/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.0.1
 */

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const SET_HELP_FLAG = '@@b2b_portal_ui/header/SET_HELP_FLAG';
export const SET_HELP_FLAG_FAIL = '@@b2b_portal_ui/header/SET_HELP_FLAG_FAIL';
export const SET_HELP_FLAG_SUCCESS = '@@b2b_portal_ui/header/SET_HELP_FLAG_SUCCESS';

export const SET_HELP_TIP_TEXT = '@@b2b_portal_ui/header/SET_HELP_TOOLTIP_TEXT';
